export default {
  "tr-tab.comfortweather.com": {
    ad1: [
      // 首页顶部tab下广告
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224491850-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x100_top",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 2292469499,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "position-08",
      },
      // 底部悬浮banner
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224536341-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x100_under",
        // rect: [320, 100],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "100px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 2954510555,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "position-01",
      },
      /**
       * 说明：
       * 传音中部位当前代码资源里没有单独下发新的 320x100 数字 slot，
       * 先按独立位置补齐结构，后续如果广告后台补发专用 code，只需替换这里的 slot。
       */
      {
        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 2292469499,
        style: { display: "inline-block", width: "320px", height: "100px" },
        position: "position-36",
      },
    ],
    ad2: [
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224561758-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x250_1",
        // rect: [320, 250],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "250px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 4111983474,
        style: { display: "inline-block", width: "320px", height: "250px" },
        position: "position-09",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224587965-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x250_2",
        // rect: [320, 250],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "250px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 8016780914,
        style: { display: "inline-block", width: "320px", height: "250px" },
        position: "position-13",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224617695-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x250_3",
        // rect: [320, 250],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "250px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 1531263616,
        style: { display: "inline-block", width: "320px", height: "250px" },
        position: "position-14",
      },
      {
        // type: "adx",
        // id: "div-gpt-ad-1778224665986-0",
        // slot: "/23161678951/tr_tab_comfortweather_20260508_320x250_4",
        // rect: [320, 250],
        // style: {
        //   minWidth: "320px",
        //   minHeight: "250px",
        // },

        type: "ads",
        client: "ca-pub-7826482262281669",
        slot: 7825209226,
        style: { display: "inline-block", width: "320px", height: "250px" },
        position: "position-15",
      },
    ],
  },
};
